module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "20",
      "height": "18",
      "viewBox": "0 0 10 10",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.42271 0.104911L8.8245 2.5067C8.89146 2.57366 8.92941 2.66518 8.92941 2.76004V4.73874C8.68259 4.56181 8.41363 4.39331 8.12584 4.24791V3.68304H5.71512C5.5908 3.68304 5.47157 3.63365 5.38367 3.54574C5.29576 3.45783 5.24637 3.33861 5.24637 3.21429V0.803571H1.87584V9.19643H2.88485C3.09005 9.38242 3.31398 9.56778 3.55415 9.74189C3.67635 9.83048 3.80409 9.91712 3.93697 10H1.42941C1.23186 10 1.07227 9.8404 1.07227 9.64286V0.357143C1.07227 0.159598 1.23186 0 1.42941 0H6.17048C6.26535 0 6.35575 0.0379464 6.42271 0.104911ZM6.0053 2.92411H8.10575L6.0053 0.823661V2.92411Z",
      "fill": "#83BBAC"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M4.65706 6.03606C4.16663 6.3889 3.7656 6.82205 3.51142 7.13063C3.47373 7.17648 3.44637 7.20981 3.42381 7.23896C3.41999 7.2439 3.4165 7.24846 3.41333 7.25269C3.4165 7.25691 3.41999 7.26147 3.42381 7.26641C3.44637 7.29556 3.47373 7.32889 3.51142 7.37474C3.76559 7.68332 4.16663 8.11647 4.65706 8.46931C5.15104 8.82469 5.69836 9.07189 6.25439 9.07189C6.81042 9.07189 7.35774 8.82469 7.85172 8.46931C8.34211 8.11651 8.74311 7.6834 8.99729 7.37483C9.03502 7.32893 9.0624 7.29558 9.08497 7.26641C9.08879 7.26147 9.09228 7.25691 9.09545 7.25268C9.09228 7.24846 9.08879 7.2439 9.08497 7.23896C9.0624 7.20979 9.03502 7.17644 8.99729 7.13054C8.74311 6.82197 8.34211 6.38886 7.85172 6.03606C7.35774 5.68068 6.81042 5.43348 6.25439 5.43348C5.69836 5.43348 5.15104 5.68068 4.65706 6.03606ZM4.14385 5.3227C4.71518 4.91166 5.44171 4.55469 6.25439 4.55469C7.06707 4.55469 7.7936 4.91166 8.36493 5.3227C8.93973 5.73623 9.39542 6.23166 9.67579 6.57205L9.67606 6.57238C9.68505 6.58332 9.69461 6.59475 9.7046 6.60669C9.82109 6.74597 9.99511 6.95402 9.99511 7.25269C9.99511 7.55135 9.82109 7.7594 9.70459 7.89869C9.69461 7.91062 9.68505 7.92205 9.67606 7.93299L9.67579 7.93332C9.39542 8.27371 8.93973 8.76914 8.36493 9.18267C7.7936 9.59371 7.06707 9.95068 6.25439 9.95068C5.44171 9.95068 4.71518 9.59371 4.14385 9.18267C3.56905 8.76914 3.11336 8.27371 2.83299 7.93332L2.83272 7.93299C2.82373 7.92205 2.81417 7.91062 2.80419 7.89868C2.68769 7.7594 2.51367 7.55135 2.51367 7.25269C2.51367 6.95402 2.68769 6.74597 2.80419 6.60668C2.81417 6.59475 2.82373 6.58332 2.83272 6.57238L2.83299 6.57205C3.11336 6.23166 3.56905 5.73623 4.14385 5.3227Z",
      "fill": "#83BBAC"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.2543 8.38263C6.878 8.38263 7.3836 7.87702 7.3836 7.25332C7.3836 6.62963 6.878 6.12402 6.2543 6.12402C5.63061 6.12402 5.125 6.62963 5.125 7.25332C5.125 7.87702 5.63061 8.38263 6.2543 8.38263Z",
      "fill": "#83BBAC"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-237cdc46", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-237cdc46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/ViewDocumentIcon.vue
// module id = 1482
// module chunks = 159